import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=6e22850b&scoped=true&"
import script from "./Disclaimer.js?vue&type=script&lang=js&"
export * from "./Disclaimer.js?vue&type=script&lang=js&"
import style0 from "./Disclaimer.vue?vue&type=style&index=0&id=6e22850b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e22850b",
  null
  
)

export default component.exports